"use client";

import Link from "next/link";
import { UserIcon } from "@/components/ui/Icons";
import { useLayoutData } from "../layout/LayoutDataProvider";

export default function AccountIconLinkClient() {
  const { templateRoutes } = useLayoutData();

  // Link directly to login 
  const href = templateRoutes?.["page-login.php"] ?? templateRoutes?.["page-account.php"];

  if (!href) return null;

  return (
    <Link href={href} aria-label="Account" className="text-title-3">
      <UserIcon className="w-[18px] h-[18px]" />
    </Link>
  ); 
}